module.exports = __webpack_public_path__ + "img/robot01_off.e2ffcb90.png";